import { useAppSelector } from "../../store/reducer";
import { canRenderExternOppgaveVisningSelector } from "../../store/selectors/selectors-oppgaveDetaljer";

import { useGetResources } from "../../hooks/useGetResources";

import styles from "../../styles/oppgave-detaljer.module.scss";

export const ExternOppgaveVisning = (): React.JSX.Element | null => {
  const canRender = useAppSelector(canRenderExternOppgaveVisningSelector);
  const resources = useGetResources();

  if (!canRender) {
    return null;
  }
  return (
    <div id="redirectinfo" className={styles.detaljer_seksjon}>
      {resources?.oppgavetype_eksternlosning_info}
    </div>
  );
};
